module.exports = __webpack_public_path__ + "static/media/Calender.cc19de3e.png";